import React from "react";
import { Text, View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";
import styles from "../../Styles";
import CoverPageHeader from "../CoverPageHeader";
import {
    formatDisplayValue,
    formatLinkedLegalEntity,
    formatPersonName,
    resolveCurrentUser,
} from "../../helpers";

const CoverPage = ({
    t,
    supplierDetail = {},
    user,
    downloadDate,
    logo,
    primaryColor,
}) => {
    const linkedLegalEntity = formatLinkedLegalEntity(supplierDetail);
    const currentUser = resolveCurrentUser(user);

    const fields = [
        {
            label: "Company name",
            value: supplierDetail?.name,
        },
        {
            label: "Assigned analyst",
            value: formatPersonName(supplierDetail?.assignedAnalyst),
        },
        {
            label: "Report Download Date",
            value: downloadDate,
        },
        {
            label: "Report Downloaded By",
            value: formatPersonName(currentUser),
        },
    ];

    if (linkedLegalEntity) {
        fields.push({
            label: "Linked Legal Entities",
            value: linkedLegalEntity,
        });
    }

    return (
        <View style={styles.coverPage}>
            <CoverPageHeader
                backgroundColor={primaryColor}
                logo={logo}
            />

            <View style={styles.coverFields}>
                {fields.map((field) => (
                    <View
                        key={field.label}
                        style={styles.coverField}
                    >
                        <Text style={styles.coverLabel}>
                            {t(field.label)}:
                        </Text>
                        <Text style={styles.coverValue}>
                            {formatDisplayValue(field.value)}
                        </Text>
                    </View>
                ))}
            </View>
        </View>
    );
};

export default withNamespaces()(CoverPage);
